import { render } from "./headerx.vue?vue&type=template&id=45f28512"
import script from "./headerx.vue?vue&type=script&lang=js"
export * from "./headerx.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__